import { DynamicFormElementConfig } from '../dynamic-form-element';

export class DynamicFormGroupConfig extends DynamicFormElementConfig {
  public children: DynamicFormElementConfig[] = [];
}
